import { isEmpty } from 'lodash';

import { QuoteType } from '@common/types';
import { HEALTH_FAST_QUOTE_STEPS, HEALTH_QUOTE_STEPS } from '@healthquote/constants';

import { useHealthQuoteStore } from './quote';
import { HealthProductDetails, HealthQuoteMember } from './types';

/**
 * get the product boundary for a product
 *
 * @param product
 * @returns TermProductBoundary
 */
export const getHealthProductDetails = (
  product: string
): HealthProductDetails | undefined => {
  const productsList = useHealthQuoteStore.getState().productsList;
  if (!isEmpty(productsList)) {
    const productDetails = productsList.find(
      (productDetail) => productDetail.product.key === product
    );
    return productDetails ?? undefined;
  }
  return undefined;
};

/**
 * Calculate the completion percentage based on the current step and total no of steps
 *
 * @param step
 * @param quote
 * @returns number
 */
export const getStepProgress = (step: number, quote: QuoteType) => {
  const index =
    quote === QuoteType.Normal
      ? Object.values(HEALTH_QUOTE_STEPS).findIndex((item) => item === step)
      : Object.values(HEALTH_FAST_QUOTE_STEPS).findIndex((item) => item === step);
  return quote === QuoteType.Normal
    ? ((index + 1) / Object.keys(HEALTH_QUOTE_STEPS).length) * 100
    : ((index + 1) / Object.keys(HEALTH_FAST_QUOTE_STEPS).length) * 100;
};

export const isMemberPresent = (member: HealthQuoteMember) => {
  const members = useHealthQuoteStore.getState().plan.members;
  return !!members.find((item) => item.relation === member);
};
